// extracted by mini-css-extract-plugin
export default {"container":"Map--container--g3Su1"};